import { Controller } from 'react-hook-form'

import { IProviderLogisticProps } from './interface'
import { Multi } from '@/components/select/multi'

const ProviderLogistic = ({
  control,
  accountKey,
  loadOptions
}: IProviderLogisticProps) => {
  return (
    <Controller
      key={accountKey}
      name='fornecedorLogistica'
      control={control}
      render={({ field: { onChange, value } }) => (
        <Multi
          value={value}
          onChange={onChange}
          label='Fornecedor Logística'
          loadOptions={loadOptions}
          isMulti={true}
          closeMenuOnSelect
        />
      )}
    />
  )
}

export default ProviderLogistic
